/**
 * @function getLocalStorageItem
 * @description Prevent errors when localStorage is inaccessible:
 *  e.g. when merchant.js is loaded in an iFrame with third-party cookies disabled.
 * @param {String} key The key name of the item.
 * @returns {?String} The item retrieved or null.
 */

export default function getLocalStorageItem (key) {
  try {
    return localStorage.getItem(key)
  } catch (e) {
    return null
  }
}
